export default function getFileName() {
    "ngInject";

    const getNameFromPath = (path) => {
          const transformed = path.split("/");
          return transformed[transformed.length - 1];
    };

    const removeCodeFromName = (name) => {
        const fullFileName = name.split(".")[0];
        const fileFormat = name.split(".")[1];
        const transformedFileNameArray = fullFileName.split("_");
        if (transformedFileNameArray.length <= 1) {
            return name;
        }
        transformedFileNameArray.pop();

        return transformedFileNameArray.join("_") + "." + fileFormat;
    };

    const trim = (file, trimCount) => {
        const shouldCount = !!trimCount && file.length > trimCount;
        trimCount = trimCount || file.length;
        file = file.slice(0, trimCount) + (shouldCount ? " ..." : "");

        return file;
    };

    return (inputString, trimCounter = 0) => {
        if (!inputString) {
            return;
        }
        inputString = getNameFromPath(inputString);
        inputString = removeCodeFromName(inputString);
        inputString = trim(inputString, trimCounter);

        return inputString;
    };
}


// WEBPACK FOOTER //
// ./sources/utility/get-file-name/get-file-name.filter.js